import React from 'react';

// Shared by the "fetch from Sylius" header button and the list showing the candidates.
export const SyliusCandidatesContext = React.createContext({
    candidates: [],
    setCandidates: () => {},
    fetchReport: null,
    setFetchReport: () => {},
    // the candidate being configured, prefilling the creation form
    prefill: null,
    setPrefill: () => {},
});
